const pagesCertificationEn = {
  add: {
    form: {
      progressbar: {
        total: "Total",
        mustItem: "Must Item",
        left: "{{value}} left",
        filled: "filled",
        modeSetting: "Mode Settings",
        mustItemOnly: "Must item only",
      },
      navigation: {
        title: "Add certification",
        steps: {
          common: {
            submitButtonLabel: "Add Certification",
          },
          certificationInformation: {
            title: "Certification information",
          },
          cards: {
            idInformation: {
              title: "Certification ID Information",
              certificationId: "Certification ID",
              certificationName: "Certification Name",
              certificationParty: "Certification Party",
              certificationHolder: "Certification Holder",
              certificationHolderPlaceholder: "Select Certification Holder",
            },
            validityPeriod: {
              title: "Validity Period",
              effectiveDate: "Effective Date",
              expirationDate: "Expiration Date (Optional)",
              renewalDate: "Renewal Date (Optional)",
            },
          },
        },
      },
      completed: {
        result: "Result",
        message: "Certification added.",
        goToCertification: "Go to certification",
        completedBy: "Completed by:",
        continueAdding: "Continue adding another certification",
      },
    },
  },
};

export default pagesCertificationEn;
